<template>
  <b-list-group-item style="text-align:left; border:0px; padding:0vw">
    <b-row style="border: 0px; font-size: 16px; margin: 0px 0px 1vw 0px">
        <b-col cols="3">{{data.Date}}</b-col>
        <b-col cols="9">
            <p v-for="i in data.Content" :key="name+'_'+i" style="margin:0px" v-html="i" />
        </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
import { BListGroupItem, BRow, BCol } from "bootstrap-vue"


export default {
  name: 'Experience',
  props: ["name", "data"],
  components:{
    BListGroupItem,
    BRow,
    BCol
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color:black;
}
</style>
